import * as API from './index'

export default {
    import: params => {
        return API.POSTFORM('/api/PlayerEntry/Import', params)
    },
    download: params => {
        return API.GETBlog('/api/PlayerEntry/Export', params)
    }, getList: params => {
        return API.GET('/api/PlayerEntry/List', params)
    },
    delete: params => {
        return API.DELETE('/api/PlayerEntry/delete', params)
    },
    deleteMatch: params => {
        return API.DELETE('/api/PlayerEntry/deleteMatch', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/PlayerEntry/DeleteBatch', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/playerentry.js